import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SESSION_TOKEN_COOKIE } from '../../../../constants/general.constants';

import { getCurrentAuthenticatedUser } from '../../../services/authService';
import { getCookie, removeCookie } from '../../../utils/cookie-methods';

export const fetchUser = createAsyncThunk('user/fetchUser', async () => {
	try {
		if (!getCookie(SESSION_TOKEN_COOKIE)) {
			return null;
		}
		const response = await getCurrentAuthenticatedUser();
		if (response?.data?.result?.user) {
			return response.data.result.user;
		} else {
			removeCookie(SESSION_TOKEN_COOKIE);
			return null;
		}
	} catch (error) {
		removeCookie(SESSION_TOKEN_COOKIE);
		return null;
	}
});

export const userSlice = createSlice({
	name: 'user',
	initialState: {
		status: 'idle',
		error: null,
		value: null,
	},
	reducers: {
		updateUser: (state, action) => {
			state.value = action.payload;
		},
		clearUser: (state) => {
			state.value = null;
		},
	},
	extraReducers: {
		[fetchUser.pending]: (state) => {
			state.status = 'loading';
		},
		[fetchUser.fulfilled]: (state, action) => {
			state.status = 'succeeded';
			state.value = action.payload;
		},
		[fetchUser.rejected]: (state, action) => {
			state.status = 'failed';
			state.error = action.error.message;
		},
	},
});

export const { updateUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
